import { shuffleArray } from './shuffleArray';
import { AnswerConfigType } from '../components/nodes/QuestionNode/types';

export const shuffle = ({ items, shuffleOptions }: {
  items: AnswerConfigType[],
  shuffleOptions?: { exceptions: string[] }
}): AnswerConfigType[] => {
  let shuffledList: AnswerConfigType[];
  if (shuffleOptions?.exceptions?.length > 0) {
    const arrayToShuffle = items.filter((item) => !shuffleOptions.exceptions.includes(item.i18n_key.split('.').slice(-1)[0]));
    const arrayToAppend = items.filter((item) => shuffleOptions.exceptions.includes(item.i18n_key.split('.').slice(-1)[0]));
    shuffledList = [...shuffleArray(arrayToShuffle), ...arrayToAppend];
  } else {
    shuffledList = shuffleArray(items);
  }
  return shuffledList;
};
